import { FC } from 'react';
import styled from 'styled-components';
import { theme } from '@salecycle/ui-component-library';

const StyledBubble = styled.div`
  width: 150%;
  position: absolute;
  top: calc(100% + 8px);
  background: white;
  padding: 20px;
  box-shadow: ${theme.vars.boxShadow.overlayMenu};
  z-index: 3;
  color: ${theme.vars.newColor.darkGS1};
`;

export const Bubble: FC = props => (
  <StyledBubble tabIndex={0} data-testid="Bubble">
    {props.children}
  </StyledBubble>
);

export default Bubble;
